import { CellularDeviceInfo } from '../../src/typings/api';
import { ICellularDeviceInfoIdentifierMappingService } from './services';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';


@Injectable({
    providedIn: 'root'
})
export class CellularDeviceInfoIdentifierMappingService implements ICellularDeviceInfoIdentifierMappingService {
    public static $name: string = 'cellularDeviceInfoIdentifierMappingService';

    /**
     * This function works on pointers from other application areas -- don't prevent them from being GC'd
     */
    public map(moduleId: number, cellularDeviceInfo: CellularDeviceInfo) {
        if (!cellularDeviceInfo && cellularDeviceInfo.updatedCellularDeviceInfoIdentifiers) {
            return;
        }

        if (!cellularDeviceInfo.cellularDeviceInfoIdentifiers) {
            cellularDeviceInfo.cellularDeviceInfoIdentifiers = [];
        }

        // Make a copy so deletion doesn't affect UI
        let updatedIdentifiers = _.cloneDeep(cellularDeviceInfo.updatedCellularDeviceInfoIdentifiers);

        // Updates existing identifiers
        let i = 0;
        let len = cellularDeviceInfo.cellularDeviceInfoIdentifiers.length;

        for (; i < len; i++) {
            let currentIdentifier = cellularDeviceInfo.cellularDeviceInfoIdentifiers[i];
            let currentUpdatedDeviceId = updatedIdentifiers[currentIdentifier.mobileIdTypeId];

            currentIdentifier.deviceId = currentUpdatedDeviceId;
            delete updatedIdentifiers[currentIdentifier.mobileIdTypeId];
        }

        // Creates new identifiers for the ones that weren't present before
        // At this point, the pre-existing ones should have been deleted from the object we're looping over
        for (let key in updatedIdentifiers) {
            cellularDeviceInfo.cellularDeviceInfoIdentifiers.push({
                deviceId: updatedIdentifiers[key],
                mobileIdTypeId: key,
                moduleId: moduleId
            });
        }

        /**
         * Before this function is called, the allowedMobileIdTypes property
         * should have been updated with the mobileIdTypes allowed for the currently selected carrier.
         * We should filter out the ones that aren't present here from the result,
         * otherwise we will save any data that was entered (or already existed) for other carriers
         */
        let allowedMobileIdTypeIds = cellularDeviceInfo.allowedMobileIdTypes.map((mobileIdType) => mobileIdType.id);

        cellularDeviceInfo.cellularDeviceInfoIdentifiers =
            cellularDeviceInfo.cellularDeviceInfoIdentifiers
                              .filter((identifier) => allowedMobileIdTypeIds.indexOf(identifier.mobileIdTypeId) > -1);
    }
}
